<template>
  <video
    ref="video"
    :class="videoClass"
    :autoplay="autoPlay"
    :muted="muted"
    :loop="loop"
    :controls="controls"
    playsinline=""
    @blur="handleBlur"
    @focus="handleFocus"
  >
    <source
      :data-src="videoUrl"
      type="video/mp4"
    >
  </video>
</template>

<script>

import lozad from '../plugins/lozad_'
export default {
  props: {
    videoUrl: String,
    videoClass: String,
    autoPlay: Boolean,
    muted: Boolean,
    loop: Boolean,
    controls: Boolean

  },

  watch:
            {
              videoUrl () {
                this.$nextTick(() => {
                  this.$el.setAttribute('data-loaded', false)
                  lozad(this.$el).triggerLoad(this.$el)
                })
              }
            },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('focus', this.handleFocus)
    window.addEventListener('blur', this.handleBlur)

    this.$nextTick(() => {
      this.$el.classList.toggle('lozad')
      lozad(this.$el).observe()
    })
  },
  destroyed () {
    // window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('focus', this.handleFocus)
    window.removeEventListener('blur', this.handleBlur)
  },
  methods: {
    isInViewport () {
      const bounding = this.$refs.video.getBoundingClientRect()
      return (
      // bounding.top >= (0 - 0.75*bounding.height) &&
      // (bounding.bottom >= 0 || bounding.bottom <= (bounding.height + bounding.height/3) )
        bounding.top >= (0 - 0.75 * bounding.height) && bounding.top < (window.innerHeight || document.documentElement.clientHeight)
      // bounding.top >= 0 && bounding.top < (window.innerHeight || document.documentElement.clientHeight)

      )
    },
    handleScroll (event) {
      // console.log('Scroll!');
      // console.log('getAttribute', this.$el.getAttribute("data-loaded"));
      if (this.$refs.video.getAttribute('data-loaded')) {
        if (this.isInViewport()) {
          // console.log('In viewport');
          if (this.$refs.video.paused) {
            this.$refs.video.play()
          }
        } else {
          // console.log('Not in viewport');
          if (!this.$refs.video.paused) {
            this.$refs.video.pause()
          }
        }
      }
    },
    handleFocus () {
      if (this.$refs.video.getAttribute('data-loaded')) {
        if (this.$refs.video.paused) {
          this.$refs.video.play()
        }
      }
    },
    handleBlur () {
      if (this.$refs.video.getAttribute('data-loaded')) {
        if (!this.$refs.video.paused) {
          this.$refs.video.pause()
        }
      }
    }
  }

}
</script>
